module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2d.4d18c239.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-2d.svg
// module id = 543
// module chunks = 0